const AIF_INFO_FIELDS = [
  'aifm_national_code',
  'aif_national_code',
  'aif_name',
  'aif_eea_flag',
  'aif_reporting_code',
  'aif_domicile',
  'inception_date',
  'aif_no_reporting_flag'
];
const HFT_FIELDS = ['hft_transaction_number', 'hft_buy_sell_market_value'];
const INVESTOR_REDEMPTION_FIELDS = [
  'provide_withdrawal_rights_flag',
  'investor_redemption_frequency',
  'investor_redemption_notice_period',
  'investor_redemption_lockup_period'
];

export const SECTION_ERROR_SCOPE = {
  // Tables below have no own sidebar entry — their errors surface under the section above them
  MASTER_AIF_STATUS: { tableKey: ['MASTER_AIF_STATUS', 'MASTER_AIF'] },
  MARKET_RISK_MEASURE: {
    tableKey: [
      'MARKET_RISK_MEASURE',
      'VALUE_FOR_YEARS_RISK_MEASURE',
      'VEGA_RISK_MEASURE',
      'VAR_RISK_MEASURE'
    ]
  },
  INVESTOR_ILLIQUID_ASSET_ARRANGEMENT: {
    tableKey: ['INVESTOR_ILLIQUID_ASSET_ARRANGEMENT', 'INVESTOR_PREFERENTIAL_TREATMENT']
  },
  ASSUMPTIONS2: { tableKey: 'HEADER_SECTION', mode: 'include', fields: AIF_INFO_FIELDS },
  HEADER_SECTION: { tableKey: 'HEADER_SECTION', mode: 'exclude', fields: AIF_INFO_FIELDS },
  INVESTMENT_STRATEGIES2: {
    tableKey: 'INVESTMENT_STRATEGIES',
    mode: 'include',
    fields: HFT_FIELDS
  },
  INVESTMENT_STRATEGIES: {
    tableKey: 'INVESTMENT_STRATEGIES',
    mode: 'exclude',
    fields: HFT_FIELDS
  },
  INVESTOR_LIQUIDITY_PROFILE2: {
    tableKey: 'INVESTOR_LIQUIDITY_PROFILE',
    mode: 'include',
    fields: INVESTOR_REDEMPTION_FIELDS
  },
  INVESTOR_LIQUIDITY_PROFILE: {
    tableKey: 'INVESTOR_LIQUIDITY_PROFILE',
    mode: 'exclude',
    fields: INVESTOR_REDEMPTION_FIELDS
  },
  HISTORICAL_PROFILE: { tableKey: 'HISTORICAL_PROFILE', rowTypes: ['GROSS', 'NET', 'NAV_CHANGE'] },
  HISTORICAL_PROFILE2: { tableKey: 'HISTORICAL_PROFILE', rowTypes: ['SUBSCRIPTION', 'REDEMPTION'] }
};
